var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tag_svg__tag",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".tag_svg__cls-2{fill:currentColor}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tag_svg__Group_21619",
    "data-name": "Group 21619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "tag_svg__Path_17722",
    "data-name": "Path 17722",
    className: "tag_svg__cls-2",
    d: "m21.41 11.58-9-9A1.987 1.987 0 0 0 11 2H4a2.006 2.006 0 0 0-2 2v7a2 2 0 0 0 .59 1.42l9 9A1.987 1.987 0 0 0 13 22a1.955 1.955 0 0 0 1.41-.59l7-7A1.955 1.955 0 0 0 22 13a2.02 2.02 0 0 0-.59-1.42zM13 20.01 4 11V4h7v-.01l9 9z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "tag_svg__Ellipse_1815",
    "data-name": "Ellipse 1815",
    className: "tag_svg__cls-2",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(5 5)"
  }))));
};

export default SvgTag;